import { styled } from 'styled-components';

import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsSplitContentVideoContentButton = styled.div<{
  $fullWidth: boolean;
}>`
  appearance: none;

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    aspect-ratio: 649 / 370;
    border-radius: 24px;
    overflow: hidden;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 100%;
    height: 100%;
    border-radius: ${(props) => (props.$fullWidth ? undefined : '24px')};
    overflow: ${(props) => (props.$fullWidth ? undefined : 'hidden')};
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) and (max-width: ${cssBreakpoints.lgDown}) {
    min-height: 25vw;
  }

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    min-height: ${(540 * 9) / 16};
  }
`;

export const CmsSplitContentVideoContentPlayButtonHolder = styled.div<{
  $index: number;
}>`
  position: absolute;
  top: 50%;

  @media all and (max-width: ${cssBreakpoints.smDown}) {
    left: 50%;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    left: ${(props) => (props.$index === 0 ? '25%' : '75%')};
  }
`;

export const CmsSplitContentVideoContent_Box_1 = styled.div`
  width: 100%;
  padding-inline: ${gutterWidth / 4}px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    width: 50%;
    padding-inline: ${gutterWidth / 2}px;
  }

  &[data-not-full-width] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      position: relative;
    }
  }

  &[data-not-desktop-only] {
    padding-block: ${gutterWidth / 4}px;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      padding-block: ${gutterWidth / 2}px;
    }
  }
`;

export const CmsSplitContentVideoContent_Box_2 = styled.div`
  width: 100%;
  height: 100%;
  margin-left: 0;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    left: 50%;
    top: 50%;
  }

  &[data-full-width-and-not-preview] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      position: absolute;
      transform: translate(-50%, -50%);
    }
  }

  &[data-overlapping] {
    margin-top: 0;

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      margin-top: -${gutterWidth}px;
      height: calc(100% + ${gutterWidth * 2}px);
    }
  }

  &[data-overlapping][data-full-width] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      width: 100vw;
    }
  }

  &[data-overlapping]:not([data-full-width]) {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      width: calc(100% + ${gutterWidth * 3}px);
    }
  }

  &[data-full-width]:not([data-overlapping]) {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      height: calc(100% + ${gutterWidth}px);
    }
  }

  &[data-overlapping-first] {
    @media all and (min-width: ${cssBreakpoints.smUp}) {
      margin-left: -${gutterWidth * 3}px;
    }
  }
`;
